export let projectsList = [
    {
         ind: 1,
        src: './Images/Projects/portfolio.png',
        desc: ['Constructed a personalized portfolio website through ReactJS. Deployed tsParticles.js library for an interactive background. Employed Framer-motion animations for enhanced user viewability. Included custom 3D Objects through the usage of Three.js library to showcase advanced web development skills. '],
        title: 'Portfolio Website',
        tech: 'ReactJS | Bootstrap | Particles.js | Three.js',
        link: 'https://basedanuragportfolio.netlify.app/',
        demo: ''
    },
    {
         
        ind: 2,
        src: './Images/Projects/CyberVayuNexusLogo.png',
        desc: [' Cyber Vayu Nexus is an AI-powered defense project designed to detect and classify drones in real time using computer vision and deep learning. Built with a Python-based GUI, it provides a visual interface for monitoring aerial activity, identifying potential threats, and alerting operators instantly.The system leverages OpenCV, TensorFlow, and image processing algorithms to analyze live video feeds and distinguish between drones and other flying objects. It’s optimized for real-time inference and situational awareness in defense environments.Key Highlights:Built a fully interactive Python GUI for real-time drone detection and tracking.Integrated deep learning models for accurate object recognition.Designed to assist defense and security teams in counter-drone operations.Recognized and shortlisted under the Government of India’s Yukti Innovation Program (2025) for its national security application.'],
        title: 'CyberVayuNexus',
        tech : 'Python,YoloV8, OpenCV, TensorFlow, Tkinter, NumPy',
        link: 'https://github.com/basedanurag/CyberVayu.git',
        demo: 'https://drive.google.com/file/d/1Jb2_tw5lUWeB9GNyVb1YLLl8x6nIlqtZ/view?usp=drive_link'

    },
    {
        
        ind: 3,
        src: './Images/Projects/KSHETRA.png',
        desc: ['KSHETRA is a Rust-powered geographic intelligence system designed to provide real-time analysis and visualization of spatial and environmental data. It combines high-performance Rust backend logic with a modern Vite + React frontend, enabling secure, scalable, and lightning-fast geospatial computations. The platform processes and maps regional datasets to support smart governance, defense planning, and resource optimization. KSHETRA’s modular architecture makes it adaptable for both centralized dashboards and decentralized node-based deployments, ensuring reliability even in low-connectivity environments. '],
        title: 'KSHETRA',
        tech : 'Rust(Backend) + IC-CDK, VITE (frontend)',
        link: 'https://github.com/basedanurag/kshetra',
        demo: ''

    },
    {
        
        ind: 4,
        src: './Images/Projects/text.png',
        desc: [' AI tool that automatically reviews codebases, detects logic and performance issues, and suggests improvements using NLP and ML models. Links Coming Soon'],
        title: 'AI-Powered Code Review Agent',
        tech : 'React,Java SpringBoot, Python,Microservices',
        link: '',
        demo: ''

    },
    {
        
        ind: 5,
        src: './Images/Projects/text.png',
        desc: [' Offline Java desktop suite with 20+ tools (JSON/YAML formatters, JWT/Base64 encoders, UUID/hash generators). Built with JavaFX, CSS, and packaged using jpackage for cross-platform use.Links Coming Soon'],
        title: 'DevKit - JAVA Offline Tool Kit',
        tech : 'JavaFX, CSS, Java',
        link: '',
        demo: ''

    },
    
    {
        ind: 6,
        src: './Images/Projects/text.png',
        desc: [' '],
        title: 'Project Coming Soon',
        tech : '',
        link: '',
        demo: ''
    },
];